import { authenticatedApiFetch } from '../utils/utils'


export const allFoldersForClassService = async (classId, parentFolder = '') => {
    if (!classId) {
        return []
    }
    const res = await authenticatedApiFetch(`/folders/?classes=${classId}&parent_folder_id=${parentFolder}`, { method: 'GET' })
        .then(res => res.json())
        .catch(error => {
            console.error(error)
            return []
        })
    return Array.isArray(res) ? res : (res?.results ?? [])
}


export const getFolderService = async (id) => {
    const res = await authenticatedApiFetch(`/folders/${id}`, { method: 'GET' })
        .then(res => res.json())
        .catch(error => console.error(error))
    return res
}

export const updateFolderService = async (id, data) => {
    const res = await authenticatedApiFetch(`/folders/${id}/`, { 
        method: 'PATCH', 
        body: JSON.stringify(data) 
    })
        .then(res => res.json())
        .catch(error => {throw error})
    return res
}

export const createFolderService = async (data) => {
    const res = await authenticatedApiFetch('/folders/', {
        method: 'POST',
        body: JSON.stringify(data)
    })
        .then(res => res.json())
        .catch(error => { throw error })
    return res
}
